<template>
  <common-dialog ref="dialog" :title="title" width="1000px" :in-dialog="inDialog">
    <div class="index-tree-box">
      <type-tree ref="tree" auto-h show-action @on-select="treeSelect" @title-click="titleClick" />
      <div class="right-box">
        <list ref="list" common :show-checkbox="multiple" is-select>
          <template #column>
            <slot name="column" />
            <template v-if="selectable&&!multiple">
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{row}">
                  <el-button @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
      </div>
    </div>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
import typeTree from "./type/tree";

export default {
  components: { commonDialog, list, typeTree },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "颜色列表",
    },
  },
  data() {
    return {
      params: {},
      IdChain: null,
    };
  },
  methods: {
    getData(params = {}) {
      this.params = { ...params };
      this.$refs.tree.getData();
      this.$refs.list.getData({...this.params, IdChain: this.IdChain});
    },
    treeSelect(data) {
      this.IdChain = data.IdChain;
      this.$refs.list.getData({ ...this.params, IdChain: data.IdChain });
    },
    titleClick() {
      this.IdChain = null;
      this.$refs.list.getData({ ...this.params, IdChain: null });
    },
  },
};
</script>